import "./Marquee.scss";

export default function Marquee({
  children = "VSCX4 Weekend October 16th-18th!",
}) {
  const copies = Array.from({ length: 20 });

  const group = copies.map((_, index) => (
    <span
      className="marquee__text luckiest-guy-regular"
      key={index}
    >
      {children}
    </span>
  ));

  return (
    <div className="marquee">
      <div className="marquee__track">
        <div className="marquee__group">
          {group}
        </div>

        <div className="marquee__group" aria-hidden="true">
          {group}
        </div>
      </div>
    </div>
  );
}